module.exports = function(ads) {
	'use strict'
	ads.directive('adsSettingsDir',adsSettingsDir);
	adsSettingsDir.$inject=[];
	function adsSettingsDir() {
		return {
			template: require('./partial/adsSettings.html'),
			controller:'adsSettingsController',
			controllerAs:'vmas',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/settings/js/directive/adsSettingsDirective.js
// module id = 484
// module chunks = 0